// function for setting cell color based on percentage //
import React from "react"
import tinycolor from 'tinycolor2'

const Dist = ({ share, max_color, percision }) => {

    // func for imperceisely handling float-point rounding hell //
    function truncate (num, places) {
        return Math.trunc(num * Math.pow(10, places)) / Math.pow(10, places);
    }

    var parsedShare = parseFloat(share)

    const zero_color = '#ffffff'

    return (
        <div style={{
            background : tinycolor.mix(zero_color, max_color, 100 * parsedShare ),
            height: '100%',
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        }}>
            {truncate(100*parsedShare, percision)}%
        </div>
    )
    
}

export default Dist